import React, { useState, useEffect } from 'react'
import { AiOutlinePlusCircle, AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import axios from 'axios'
import { useNavigate } from 'react-router-dom';
import { FaTimes, FaEye } from 'react-icons/fa';
import ToastNotification from '../../../components/ToastNotification';
import { FaEquals } from 'react-icons/fa';
import { MdEdit } from "react-icons/md";
import { Modal, Button, Table, Form } from "react-bootstrap";
import Select from 'react-select'
import { useLoading } from '../../../context/LoadingContext';
import socket from "../../../socket";

const PORequistion = ({adminData,branchID,financialYear}) => {

        const getTodayDateTime = () => {
        const now = new Date();
        now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
        return now.toISOString().slice(0, 16);
    }; 


    const [issue, setIssue] = useState({
        emp_id: '',
        issue_date: getTodayDateTime(),
        ref_doc: '',
        remark: '',
        note_type: '',
        material_status: '',
        branchId:'',
    })
    const [formData, setFormData] = useState([
        {
            id: '',
            qty: '',
            name: "",
            rate: '',
            amount: '',
        }
    ]);

    const [files, setFiles] = useState({
        file: null,
        existing_file: null,

    })
      const { setLoading } = useLoading();
    const [isEditMode, setIsEditMode] = useState(false);
    const [showAddForm, setShowAddForm] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [user, setUser] = useState([]);
    const [items, setItems] = useState([]);
    const [selectedItemId, setSelectedItemId] = useState("");
    const [tech, setTech] = useState([]);
    const [fetchIssue, setFetchIssue] = useState([])
    const [showItemModal, setShowItemModal] = useState(false);
    const [viewModalData, setViewModalData] = useState(null);
    const [showViewModal, setShowViewModal] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [activeRowIndex, setActiveRowIndex] = useState(null);
    const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
    const showToast = (msg, bg = 'success') => {
        setToast({ show: true, message: msg, bg });
    };
    const [selectedTech, setSelectedTech] = useState(null);
    const [noteType, setNoteType] = useState(null);
     const [editingCompanyId, setEditingCompanyId] = useState(null)
     const [branchDetail, setBranchDetail] = useState([])
     
       const [offset, setOffset] = useState(0);
                  const limit = 20;
                  const [hasMore, setHasMore] = useState(true);
                  const [fromDate, setFromDate] = useState();
                  const [toDate, setToDate] = useState();
                  const [isLocked, setIsLocked] = useState(false);
                  const [fy, setFy] = useState([]);
              
                  const [financialRange, setFinancialRange] = useState({
                      from_date: '',
                      to_date: ''
                  });


              useEffect(() => {
              
                socket.on("material-request", (data) => {
                   showToast(data.message, "info");
                });
              
                return () => socket.off("material-request");
              }, []);      


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setIssue(prev => ({ ...prev, [name]: value }));
    };

    const handleItemChange = (index, itemId) => {
        const selectedItem = items.find(i => i.id === itemId);
        if (!selectedItem) return;

        setFormData(prev => {
            const updated = [...prev];
            updated[index] = {
                ...updated[index],
                id: itemId,
                name: selectedItem.name
            };
            return updated;
        });
    };


    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const fileSizeInMB = file.size / (1024 * 1024);
            if (fileSizeInMB > 2) {
                setToast("File size is too large! Please upload a file smaller than 2MB.", 'danger')
                return;
            }
            setFiles(prevFiles => ({ ...prevFiles, [e.target.name]: file }));
        }
    };


    const itemOptions = items.map(i => ({
        value: i.id,
        label: `${i.name} `
    }));


    const addRow = () => {
        setFormData(prev => [...prev, { id: "", name: "", qty: "" }]);
    };

    const typeOptions = [
        { value: "issue", label: "Issue" },
        { value: "return", label: "Return" }
    ];

    const currentTypeOptions = (isEditMode && noteType === "request")
        ? [
            { value: "issue", label: "Issue" },
            { value: "return", label: "Return" },
            { value: "request", label: "Request (Legacy Issue)" }
          ]
        : typeOptions;


    const fectEmphDetail = async () => {
        try {
            const resEmployee = await axios.get('https://api.skyguard.group/api/fetch-employee');
               const filtered = (resEmployee.data.result || []).filter(
      emp => emp.emp_id !== null && emp.emp_id !== undefined && emp.emp_id !== ""
    );

    setUser(filtered);
        } catch (error) {
            console.log(error)
        }
    };

    const fecthInventoryDetail = async () => {
        try {
            const resInventory = await axios.get('https://api.skyguard.group/api/fetch-inventory');
            const items = resInventory.data.result || [];
            setItems(items);
        } catch (error) {
            console.log(error)
        }
    };


    const options = user.map(t => ({
        value: t.id,
        label: `${t.first} ${t.middle}  ${t.last} - ${t.emp_id}`
    }));


    const purchaseRequisition = async (fromDate,
        toDate,
        branchCode,
        newOffset = 0) => {

             if (!branchCode) {
            console.log("Branch code missing");
            return;
        }
        try {
            const res = await axios.get('https://api.skyguard.group/api/fetch-requisition',
                 {
                    params: {
                        from_date: fromDate,
                        to_date: toDate,
                        branch_code: branchCode,
                        limit: limit,
                        offset: newOffset
                    }
                }
            );
            

                const sortedData = res.data.sort((a, b) => {
            return new Date(b.issue_date) - new Date(a.issue_date);
        });

        // setFetchIssue(sortedData);
         const result = sortedData;
            if (newOffset === 0) {
                setFetchIssue(result);
                setHasMore(true);
            }

            else {
                setFetchIssue(prev => {
                    const merged = [...prev, ...result];

                    // optional: remove duplicates (safety)
                    const unique = Array.from(
                        new Map(merged.map(item => [item.id, item])).values()
                    );

                    return unique;
                });
            }

            // check if more data exists
            if (result.length < limit) {
                setHasMore(false);
            }
        } catch (error) {
            console.log(error)
        }
    };

      const fetchBranchDetail = async () => {
        setLoading(true)
        try {
            const branchRes = await axios.get(`https://api.skyguard.group/api/fetch-branch-localData/${branchID}`);
            setBranchDetail(branchRes.data)
            return branchRes.data.code;
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false);
        }
    };

       const fetchYearDetail = async () => {
                        setLoading(true);
                        try {
                            const branchCode = await fetchBranchDetail();
                            const res = await axios.get(
                                `https://api.skyguard.group/api/fetch-financial-year-localData/${financialYear}`
                            );
                            const yearData = res.data;
                            setFy(yearData);
                            setIsLocked(yearData.is_locked === 1);
                            setFinancialRange({
                                from_date: yearData.from_date,
                                to_date: yearData.to_date
                            });
                
                            await purchaseRequisition(
                                yearData.from_date,
                                yearData.to_date,
                                branchCode,
                
                            );
                        } catch (error) {
                            console.log(error);
                        } finally {
                            setLoading(false);
                        }
                    };

    useEffect(() => {

        fectEmphDetail();
        fecthInventoryDetail();
        fetchBranchDetail();
    fetchYearDetail();
    }, []);



    const fullName = `${adminData?.user.first || ''} ${adminData?.user.middle || ''} ${adminData?.user.last || ''}`.trim();
    const editName = `${adminData?.user.first || ''} ${adminData?.user.middle || ''} ${adminData?.user.last || ''}`.trim();

    const handleSubmit = async (e) => {
        e.preventDefault();
        const cleanedItems = formData
            .filter(i => i.id && i.qty)
            .map(i => ({
                id: i.id,
                name: i.name,
                qty: Number(i.qty),
                rate: i.rate || 0,
                amount: i.amount || 0,
            }));

        const sendData = new FormData();
        sendData.append("note_type", 'requisition');
        sendData.append("emp_id", selectedTech?.value || "");
        sendData.append("issue_date", issue.issue_date || new Date().toISOString().slice(0, 16));
        sendData.append("remark", issue.remark);

        sendData.append("material_status", noteType || "issue");
        sendData.append("items", JSON.stringify(cleanedItems));
        sendData.append("existing_file", files.existing_file || "");
          sendData.append('added_by', fullName)
        sendData.append("branchId", branchDetail.code);

        if (files.file) {
            sendData.append("file", files.file);
        }

        try {
            if (isEditMode && editingCompanyId) {
                   sendData.append("edit_by", editName);
                await axios.put(
                    `https://api.skyguard.group/api/update-requisition/${editingCompanyId}`,
                    sendData,
                    { headers: { "Content-Type": "multipart/form-data" } }
                );
                showToast("Material Requisition updated successfully!", "success");
            } else {
                await axios.post(
                    "https://api.skyguard.group/api/add-requisition",
                    sendData,
                    { headers: { "Content-Type": "multipart/form-data" } }
                );
                showToast("Material Requisition created successfully!", "success");
            }

            setShowAddForm(false);
            setIsEditMode(false);
            setIssue({ emp_id: '', issue_date: '', ref_doc: '', remark: '' });
            setFormData([{ id: '', qty: '', name: '', rate: '', amount: '' }]);
            setNoteType([])
            setSelectedTech(null)
           purchaseRequisition(financialRange.from_date,
            financialRange.to_date,
            branchDetail.code,
            0);
        } catch (err) {
            console.error(err);
            showToast("Failed to save requisition!", "danger");
        }
    };


    const handleEdit = (s) => {
        let parsedItems = [];
        try {
            parsedItems = s.items ? JSON.parse(s.items) : [];
        } catch (err) {
            console.error("❌ Error parsing items JSON:", err);
        }

        setIssue({
             issue_id: s.issue_id || s.id || '',
            emp_id: s.emp_id || '',
            issue_date: s.issue_date || '',
            ref_doc: s.ref_doc || '',
             branchId:s.branchId || "",
            remark: s.remark || '',
        });

        setFormData(parsedItems);

        setFiles({
            file: null,
            existing_file: s.file || null,
        });


         if (s.emp_id) {
        const tech = options.find(opt => opt.value === s.emp_id);
        setSelectedTech(tech || null);
    } else {
        setSelectedTech(null);
    }

 
    if (s.material_status) {
        setNoteType(s.material_status);
    } else {
        setNoteType('issue');
    }
            setEditingCompanyId(s.id);
        setSelectedItemId(s.id);
        setIsEditMode(true);
        setShowAddForm(true);
    };

   
const filteredData = searchTerm
  ? fetchIssue.filter(itm =>
      Object.values(itm).some(val =>
        String(val || '').toLowerCase().includes(searchTerm.toLowerCase())
      )
    )
  : fetchIssue;


     const handleLoadMore = () => {

        const nextOffset = offset + limit;
        setOffset(nextOffset);

        purchaseRequisition(
            financialRange.from_date,
            financialRange.to_date,
            branchDetail.code,
            nextOffset
        );
    };

    return (
        <>
            <div className='main-section'>
                <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
                    <h3 className='my-3 fw-bold fs-5 golos'>Material Requisition</h3>
                    <ToastNotification
                        show={toast.show}
                        message={toast.message}
                        bg={toast.bg}
                        onClose={() => setToast({ ...toast, show: false })}
                    />

                    <div className="mb-3 row gx-2 gy-2 d-flex justify-content-between">
                        <div class="mb-3 row gx-3 gy-2 align-items-center d-flex justify-content-between">
                            <div class="col-12 col-md-9">
                                <div className="row my-3 align-items-center">
                                    {/* Input */}
                                    <div className="col-md-4">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Search By Technician name"
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 col-md-2 d-flex justify-content-end">
                                <button
                                    className={`btn ${showAddForm ? 'btn-danger' : 'btn-success'}`}
                                    onClick={() => {
                                        setShowAddForm(!showAddForm);
                                    }}
                                >
                                    {showAddForm ? 'Cancel' : 'Add'}{' '}
                                    {showAddForm ? <FaTimes size={18} /> : <AiOutlinePlusCircle size={20} />}
                                </button>
                            </div>
                        </div>
                    </div>

                    {showAddForm && (
                        <div className='card p-3 mb-4'>

                               {isEditMode && (
  <div className="mb-3">
    <label>Document No:</label> <br />
    <span className="badge bg-primary px-3 py-2">
   {/* {`MR/${issue.id}/${issue.branchId}`} */}
      {`MR/${issue.issue_id || issue.id}/${issue.branchId || ""}`}
    </span>
  </div>
)}

                            <form className='row g-3' onSubmit={handleSubmit} >
                                <div className="col-md-4">
                                    <label>Technician Name</label>
                                    <Select
                                        options={options}
                                        value={selectedTech}
                                        onChange={setSelectedTech}
                                        placeholder="Select Technician"
                                        isClearable
                                    />
                                </div>


                                <div className="col-md-4">
                                    <label>Type</label>
                                    <Select
                                        options={currentTypeOptions}
                                        value={currentTypeOptions.find(o => o.value === noteType) || null}
                                        onChange={(opt) => setNoteType(opt ? opt.value : null)}
                                        placeholder="Select Type"
                                        isClearable
                                    />

                                </div>

                                <div className="col-md-4">
                                    <laebl>Date</laebl>
                                    <input
                                        type="datetime-local"
                                        className="form-control"

                                        name="issue_date"
                                        value={issue.issue_date}
                                        onChange={handleInputChange}
                                    />
                                </div>

                                <div className="table-responsive my-4">

                                    <div className="col-md-12 text-end mb-2">
                                        <button
                                            type='button'
                                            className="btn btn-success"
                                            onClick={addRow}
                                        >
                                            + Add Row
                                        </button>
                                    </div>


                                    <table className="table table-bordered mx-auto text-center align-middle w-75">
                                        <thead className="table-primary">
                                            <tr>
                                                <th style={{ width: "300px" }}>Item</th>
                                                <th style={{ width: "100px" }} >Qty</th>
                                                <th style={{ width: "100px" }}>Action</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {formData.map((item, idx) => (
                                                <tr key={idx}>
                                                    <td>
                                                        <button
                                                            type="button"
                                                            className="btn btn-outline-primary w-100"
                                                            onClick={() => {
                                                                setActiveRowIndex(idx);
                                                                setShowItemModal(true);
                                                            }}
                                                        >
                                                            {item.name ? item.name : "Search Item"}
                                                        </button>
                                                    </td>


                                                    {/* Qty */}
                                                    <td>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            value={item.qty}
                                                            onChange={(e) => {
                                                                const updated = [...formData];
                                                                updated[idx].qty = e.target.value;
                                                                setFormData(updated);
                                                            }}
                                                        />
                                                    </td>

                                                    {/* Delete */}
                                                    <td>
                                                        <button
                                                            type='button'
                                                            className="btn btn-danger btn-sm"
                                                            onClick={() =>
                                                                setFormData(formData.filter((_, i) => i !== idx))
                                                            }
                                                        >
                                                            Delete
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>

                                </div>



                                <div className="row">

                                    <div className="col-md-6">
                                        <label>Upload attachment</label>

                                        {isEditMode && files.existing_file && (
                                            <div className="mt-2">
                                                <small>Current File:</small>
                                                <a
                                                    href={`https://api.skyguard.group/uploads/${files.existing_file}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    {files.existing_file}
                                                </a>
                                            </div>
                                        )}
                                        <input
                                            type="file"
                                            className="form-control"
                                            id="attachment"
                                            name="file"
                                            accept="image/*,application/pdf"
                                            onChange={handleFileChange}
                                        />
                                    </div>

                                    <div className="col-md-6">
                                        <label>Remark</label>
                                        <textarea
                                            className="form-control"
                                            id="description"
                                            rows="5"
                                            placeholder="Enter description here..."
                                            name="remark"
                                            value={issue.remark}
                                            onChange={handleInputChange}
                                        ></textarea>
                                    </div>


                                </div>



                                <div className="col-md-12 d-grid d-flex justify-content-end">
                                 
                                    <button type="submit" className='btn btn-success w-10'>
                                        {isEditMode ? "Update" : "Save"}
                                    </button>
                                    <button type='button' className='btn btn-danger w-10 ms-2' onClick={() => {
                                        setShowAddForm(false);
                                        setIsEditMode(false);
                                        setIssue({
                                            emp_id: '',
                                            issue_date: '',
                                            ref_doc: '',

                                            remark: '',
                                        })
                                        setFormData([]);
                                        setNoteType([])
                                        setSelectedTech([]);
                                    }}>
                                        Cancel
                                    </button>
                                </div>
                            </form>
                        </div>
                    )}

                    {/* table */}
                    <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
                        <table className='table table-bordered table-striped table-hover text-center align-middle'>
                            <thead className='table-info'>
                                <tr>
                                    <th scope='col'>SN</th>
                                    <th scope='col'>Action</th>
                                    <th scope='col'>Doc No</th>
                                    <th scope='col'>Type</th>
                                    <th scope='col'>Technician Name</th>
                                    <th scope='col'>Date</th>
                                </tr>
                            </thead>
                            <tbody>

                                {filteredData.map((s, idx) => (
                                    <tr key={idx}>
                                        <td>{filteredData.length - idx}</td>
                                        <td>
                                            <button type="button"
                                                className='btn btn-info btn-sm text-white me-1'
                                                onClick={() => {
                                                    setViewModalData(s);
                                                    setShowViewModal(true);
                                                }}
                                                title='View'
                                            >
                                                <FaEye size={16} />
                                            </button>
                                            <button type="button"
                                                className='btn btn-primary btn-sm'
                                                onClick={() => handleEdit(s)}
                                                title='Edit'
                                            >
                                                <AiOutlineEdit size={16} />
                                            </button>
                                        </td>
                                        <td>{`MR/${s.id}/${s.branchId || ''}/${fy?.financial_year ? fy.financial_year.split('-')[0] : ''}`}</td>
                                        <td>
                                            <span className={`badge ${s.material_status === 'return' ? 'bg-warning text-dark' : (s.material_status === 'request' ? 'bg-secondary' : 'bg-primary')}`}>
                                                {s.material_status === 'return' ? 'Return' : (s.material_status === 'request' ? 'Request (Legacy Issue)' : 'Issue')}
                                            </span>
                                        </td>
                                        <td>
                                            {[
                                                s.tech_first_name,
                                                s.tech_middle_name,
                                                s.tech_last_name
                                            ]
                                                .filter(Boolean)
                                                .join(" ")}
                                        </td>
                                        <td>{new Date(s.issue_date).toLocaleString()}</td>
                                    </tr>
                                ))}

                                {filteredData.length === 0 && (
                                    <tr>
                                        <td colSpan="6" className='text-center text-muted'>
                                            No records found.
                                        </td>
                                    </tr>
                                )}


                            </tbody>
                        </table>
                    </div>
                    {showItemModal && (
                        <div className="modal fade show d-block " style={{ background: "rgba(0,0,0,.5)" }}>
                            <div className="modal-dialog modal-lg ">
                                <div className="modal-content ">

                                    <div className="modal-header">
                                        <h5 className="modal-title">Select Item</h5>
                                        <button
                                            type="button"
                                            className="btn-close"
                                            onClick={() => setShowItemModal(false)}
                                        />
                                    </div>

                                    <div className="modal-body">
                                        {/* 🔍 Search */}
                                        <input
                                            type="text"
                                            className="form-control mb-3"
                                            placeholder="Search by item name..."
                                            value={searchText}
                                            onChange={(e) => setSearchText(e.target.value)}
                                        />

                                        {/* Item list */}
                                        <div className='table-responsive'>
                                            <table className="table table-bordered ">
                                                <thead className='table-dark'>
                                                    <tr>
                                                        <th>Name</th>
                                                        {/* <th>Stock</th> */}
                                                        <th width="100">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {items
                                                        .filter(i =>
                                                            i.name.toLowerCase().includes(searchText.toLowerCase())
                                                        )
                                                        .map(i => (
                                                            <tr key={i.id}>
                                                                <td>{i.name}</td>
                                                                {/* <td>{i.stock}</td> */}
                                                                <td>
                                                                    <button
                                                                        className="btn btn-sm btn-success"
                                                                        onClick={() => {
                                                                            handleItemChange(activeRowIndex, i.id);
                                                                            setShowItemModal(false);
                                                                            setSearchText("");
                                                                        }}
                                                                    >
                                                                        Select
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                </tbody>
                                            </table>
                                                {hasMore && (
                            <div className="text-center mt-3">
                                <button
                                    className="btn btn-primary"
                                    onClick={handleLoadMore}
                                >
                                    Load More
                                </button>
                            </div>
                        )}
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                    )}

                </div>
            </div>
        </>
    )
}

export default PORequistion
